import React, { Component } from 'react';
import * as _ from 'lodash';
import { LabeledInput } from '../../../../../../shared/labeled-input/LabeledInput';
import { LabeledTextarea } from '../../../../../../shared/labeled-textarea/LabeledTextarea';
import './../../add-team/AddTeamModalContent.scss';
import { BlueContainedButton } from '../../../../../../shared/button/blue-contained-button/BlueContainedButton';

export class EditTeamModalContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: null,
            description: null
        };
    }

    componentDidMount() {
        if (this.props.team) {
            const { name, description } = this.props.team;

            this.setState({
                name,
                description
            });
        }
    }

    onEditUser = () => {
        _.isFunction(this.props.editTeam) && this.props.editTeam(this.state);
    };

    handleNameInputChange = name => {
        this.setState({
            ...this.state,
            name
        });
    };

    handleDescriptionInputChange = description => {
        this.setState({
            ...this.state,
            description
        });
    };

    isEditButtonDisabled = () => {
        return !this.state.name && !this.state.description;
    };

    render = () => (
        <div className={'add-team-modal-content'}>
            <div className={'add-team-fields'}>
                <LabeledInput
                    label={'Name'}
                    onChange={this.handleNameInputChange}
                    className={'add-team row'}
                    value={this.state.name}
                />
                <LabeledTextarea
                    label={'Description'}
                    onChange={this.handleDescriptionInputChange}
                    className={'add-team row'}
                    value={this.state.description}
                />
            </div>
            <BlueContainedButton
                text={'Edit Team'}
                onClick={() => this.onEditUser()}
                disabled={this.isEditButtonDisabled()}
            />
        </div>
    );
}
